<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: [
          {
            type: "map",
            map: "world",
            data: [
              { name: "China", value: 1409517397 },
              { name: "India", value: 1339180127 }
            ]
          }
        ]
      }
    };
  }
};
</script>
